import { Link } from "wouter"

function Header() {
  return (
    <header>
      <div className="logo">
        Diseño Web Menorca
      </div>
      <nav>
        <ul>
          <li className="first">
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/Servicios">Servicios</Link>
          </li>
          <li>
            <Link to="/Nosotros">Nosotros</Link>
          </li>
          <li className="last">
            <Link to="/Contacto">Contacto</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
